import React from 'react';
import { Checkbox } from "@mui/material";

export default function CampaignGroup({type, types, items, bundlesMap, selectedList, onSelectMultipleItems, onToggle}) {

    const getAbbreviationForType = (type, types) => {
        const currentType = types[type];
        if (currentType == null || currentType.metaData === null || currentType.metaData?.abbreviation === null) return '';

        return currentType.metaData?.abbreviation.trim() === '' ? '' : ' (' + currentType.metaData?.abbreviation + ')';
    }

    const groupSelectedCount = items.filter(item => selectedList?.includes(item.id)).length;
    const isAllGroupSelected = items.length > 0 && groupSelectedCount === items.length;
    const isIndeterminate = groupSelectedCount > 0 && groupSelectedCount < items.length;

    const getBundleInfo = (item) => {
        let _bundle = bundlesMap[item.bundleId] || false;
        if (item.hasOwnProperty('fixedBundle') && item.fixedBundle != null) {
            _bundle = item.fixedBundle;
        }

        if (_bundle == false) return false;

        const keys = Object.keys(_bundle.generations)
        const last_key = keys.pop()
        const prelast_key = keys.length > 0 ? keys.pop() : false

        return {
            generation: last_key,
            bundleVersion: _bundle.generations[last_key] != undefined ? _bundle.generations[last_key]['bundleVersion'] : '',
            prelastGeneration: prelast_key !== false ? prelast_key : '',
            prelastBundleVersion: prelast_key !== false ? _bundle.generations[prelast_key]['bundleVersion'] : '',
        }
    }

    const handleSelectGroup = (e) => {
        e.stopPropagation(); // Не сворачиваем группу при клике по чекбоксу
        if (onSelectMultipleItems) {
            const itemsData = items.map(item => ({ item, bundle: getBundleInfo(item) }));
            onSelectMultipleItems(itemsData, !isAllGroupSelected);
        }
    }

    return (
        <div className="campaign-type-title" onClick={onToggle}>
                    <div className="campaign-item__checkbox" onClick={(e) => e.stopPropagation()} style={{ display: 'inline-flex', alignItems: 'center',
                        marginRight: '3px',
                        position: 'relative',
                        float:'left',
                        top:'3px',
                        marginLeft:'1px' }}>
                        {onSelectMultipleItems != undefined && <Checkbox
                            onChange={handleSelectGroup}
                            checked={isAllGroupSelected}
                            indeterminate={isIndeterminate}
                            size="small"
                        />}
                    </div>
                    {type + getAbbreviationForType(type, types)}
                    <span className="campaign-type-title__amount">
                        {items.length}
                    </span>
        </div>
    )
}
